import { render, staticRenderFns } from "./SettingExpenses.vue?vue&type=template&id=4cf11469&scoped=true"
import script from "./SettingExpenses.vue?vue&type=script&lang=js"
export * from "./SettingExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf11469",
  null
  
)

export default component.exports